import Icon from '../components/Icon.vue'

Icon.register({
  'phone-volume': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M97.3 507c-129.9-129.9-129.7-340.3 0-469.9 5.7-5.7 14.5-6.6 21.3-2.4l64.8 40.5c4.5 2.8 8.1 9.3 8.1 14.6 0 1.8-0.6 4.7-1.2 6.4l-32.4 81c-2.4 6-9.5 10.8-16 10.8-0.5 0-1.2 0-1.7-0.1l-55.8-5.6c-21.1 58.3-20.6 122.5 0 179.5l55.8-5.6c0.5 0 1.2-0.1 1.7-0.1 6.4 0 13.6 4.8 16 10.8l32.4 81c0.7 1.7 1.2 4.6 1.2 6.4 0 5.3-3.6 11.8-8.1 14.6l-64.8 40.5c-2.3 1.4-6.4 2.6-9.1 2.6-3.9 0-9.4-2.3-12.2-5zM247.1 95.5c11.8 20 11.8 45 0 65.1-4 6.7-13.1 8-18.7 2.6l-6-5.7c-3.9-3.7-4.8-9.6-2.3-14.4 2-3.9 3.7-10.6 3.7-15 0-4.4-1.7-11.1-3.7-15-2.5-4.8-1.6-10.7 2.3-14.4l6-5.7c5.6-5.4 14.8-4.1 18.7 2.6zM338.9 4.3c60.1 71.6 60.1 175.9 0 247.4-4.5 5.3-12.5 5.7-17.6 0.9l-5.8-5.6c-4.6-4.4-5-11.5-0.9-16.4 49.7-59.5 49.6-145.9 0-205.4-4-4.8-3.6-12 0.9-16.4l5.8-5.6c5-4.8 13.1-4.4 17.6 0.9zM292.9 49.2c36 46.3 36.1 111.1 0 157.5-4.4 5.6-12.7 6.3-17.9 1.3l-5.8-5.6c-4.4-4.2-5-11.1-1.3-15.9 26.5-34.6 26.5-82.6 0-117.1-3.7-4.8-3.1-11.7 1.3-15.9l5.8-5.6c5.2-4.9 13.5-4.3 17.9 1.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/phone-volume.js
// module id = 1636
// module chunks = 0